var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBulk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 133,
    viewBox: "0 0 222 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1497_4013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4371 84.4788V11.9568C54.4371 8.61625 57.1451 5.9082 60.4857 5.9082H190.606C193.806 5.9082 196.4 8.50239 196.4 11.7025V84.4788C196.4 90.0016 191.923 94.4788 186.4 94.4788H64.4371C58.9142 94.4788 54.4371 90.0016 54.4371 84.4788Z",
    fill: "white",
    stroke: "#D75C43",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2041 100.422V27.9002C40.2041 24.5596 42.9122 21.8516 46.2527 21.8516H176.373C179.573 21.8516 182.167 24.4457 182.167 27.6458V100.422C182.167 105.945 177.69 110.422 172.167 110.422H50.2041C44.6813 110.422 40.2041 105.945 40.2041 100.422Z",
    fill: "white",
    stroke: "#D75C43",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.814 117.137V44.615C24.814 41.2745 27.5221 38.5664 30.8626 38.5664H160.983C164.183 38.5664 166.777 41.1606 166.777 44.3607V117.137C166.777 122.66 162.3 127.137 156.777 127.137H34.814C29.2912 127.137 24.814 122.66 24.814 117.137Z",
    fill: "white",
    stroke: "#D75C43",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1497_4013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.974,
    height: 133,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBulk);
export default __webpack_public_path__ + "static/media/emailBulk.955e6c90fde0f2396e3e9fb2b30161e9.svg";
export { ForwardRef as ReactComponent };